import { DataTableColumn } from '../../data-table.config';
import { DataTableColumnTextFilter } from '../data-table-column-text/data-table-column-text.config';

export class DataTableColumnLink extends DataTableColumn {
  value!: (item: any) => string | null | undefined;
  href!: (item: any) => string | null | undefined;

  constructor(params: {
    attribute: string;
    header: string;
    value: (item: any) => string | null | undefined;
    href: (item: any) => string | null | undefined;
    filter?: DataTableColumnTextFilter;
    width?: string;
    style?: any;
    sortable?: boolean;
  }) {
    super();
    Object.assign(this, params);
  }
}
